import { mountArray, mountArrayDisciplines, mountTitle } from "../utils/stringHelper";

export function useDropdownHook(array: any[], pathname: string, active: string) {
  const isDiscipline = pathname.includes('disciplinas');
  let urlDefinitive = "", aba = "";

  if(isDiscipline) {
    const aux = pathname.substring(0, pathname.lastIndexOf('/'));
    const aux2 = aux.substring(0, aux.lastIndexOf('/'));

    urlDefinitive = aux2.substring(0, aux2.lastIndexOf('/'));

    aba = '/tipo'+pathname.substring(pathname.lastIndexOf('/'), pathname.length);
  }
  
  const newarray = isDiscipline ? mountArrayDisciplines(array, urlDefinitive, aba) : mountArray(array, pathname);
  const title = mountTitle(array, active);

  return {
    array: newarray,
    title,
    formatSubjectArray
  };
}

const formatSubjectArray = (array: any[], pathname: string) => {
  if(array.length > 0) {
    const subject = pathname.slice(0, pathname.lastIndexOf("/"));
    const newMap = array.map((it) => ({ label: it.title, link: subject+'/'+it.slug }));

    return newMap;
  }

  return []
}